import { Container, CloseAside } from './styled';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { BannerCompany, StatusUser, LoggedWrapper } from '../../components';

export const TopBar = (props) => {

  const {
    handOpenAside,
    isOpenAside,
    userLogged,
    companiesUser
  } = props;

  return (
    <Container>
      <CloseAside onClick={handOpenAside}>
        {!isOpenAside ? <FiChevronLeft /> : <FiChevronRight />}
      </CloseAside>
      <BannerCompany />
      <div className='actions__'>
        <StatusUser />
        <LoggedWrapper
          userLogged={userLogged}
          companiesUser={companiesUser}
          isOpenAside={isOpenAside}
        />
      </div>
    </Container>
  );
};